/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import { createAction, createReducer } from 'utils/reducer';

// Local constants
const PATH = 'packagingTypes/';
const DISABLE_ERRORS = `${PATH}DISABLE_ERRORS`;
const TOGGLE_FORM = `${PATH}TOGGLE_FORM`;
const CHANGE_CONTROLS = `${PATH}CHANGE_CONTROLS`;
const TOGGLE_DELETE = `${PATH}TOGGLE_DELETE`;
const TOGGLE_EDIT_PACKAGING_TYPE = `${PATH}TOGGLE_EDIT_PACKAGING_TYPE`;
const SET_INVALID_CONTROLS = `${PATH}SET_INVALID_CONTROLS`;

// Global constants for saga
export const PACKAGING_TYPES = {
  CREATE_PACKAGING_TYPE: `${PATH}CREATE_PACKAGING_TYPE`,
  CREATE_PACKAGING_TYPE_SUCCESS: `${PATH}CREATE_PACKAGING_TYPE_SUCCESS`,
  GET_STATE_FROM_API: `${PATH}GET_STATE_FROM_API`,
  GET_STATE_FROM_API_SUCCESS: `${PATH}GET_STATE_FROM_API_SUCCESS`,
  DELETE_PACKAGING_TYPE: `${PATH}DELETE_PACKAGING_TYPE`,
  DELETE_PACKAGING_TYPE_SUCCESS: `${PATH}DELETE_PACKAGING_TYPE_SUCCESS`,
  EDIT_PACKAGING_TYPE_SUCCESS: `${PATH}EDIT_PACKAGING_TYPE_SUCCESS`,
  EDIT_PACKAGING_TYPE: `${PATH}EDIT_PACKAGING_TYPE`,
  EXPORT_PACKAGING_TYPE: `${PATH}EXPORT_PACKAGING_TYPE`,
  EXPORT_PACKAGING_TYPE_SUCCESS: `${PATH}EXPORT_PACKAGING_TYPE_SUCCESS`,
};

// actions
export const packagingTypesActions = {
  disableErrors: createAction(DISABLE_ERRORS),
  toggleForm: createAction(TOGGLE_FORM, 'modal'),
  changeControls: createAction(CHANGE_CONTROLS, 'controls', 'invalidControls'),
  toggleDelete: createAction(TOGGLE_DELETE, 'id'),
  toggleEdit: createAction(TOGGLE_EDIT_PACKAGING_TYPE, 'item'),
  setInvalidControls: createAction(SET_INVALID_CONTROLS, 'controls'),
  // api
  getStateFromApi: createAction(PACKAGING_TYPES.GET_STATE_FROM_API),
  createPackagingType: createAction(PACKAGING_TYPES.CREATE_PACKAGING_TYPE, 'controls'),
  editPackagingType: createAction(PACKAGING_TYPES.EDIT_PACKAGING_TYPE, 'id', 'controls'),
  deletePackagingType: createAction(PACKAGING_TYPES.DELETE_PACKAGING_TYPE, 'id'),

  exportPackagingTypes: createAction(PACKAGING_TYPES.EXPORT_PACKAGING_TYPE),
};

const defaultInvalidInputs = {
  name: false,
  weight: false,
};

const defaultControls = {
  name: '',
  weight: '',
  palletWeight: '',
};

const initialState = {
  formControls: { ...defaultControls },
  invalidControls: { ...defaultInvalidInputs },
  formIsOpen: false,
  deleteIsOpen: false,
  toDeleteId: '',
  toEditId: '',
  edit: false,
  error: false,
};

const packagingTypes = createReducer(initialState, {
  [DISABLE_ERRORS](state, action) {
    state.error = false;
  },
  [TOGGLE_FORM](state, action) {
    state[action.modal] = !state[action.modal];
    state.edit = false;
    state.formControls = { ...defaultControls };
    state.invalidControls = { ...defaultInvalidInputs };
  },
  [CHANGE_CONTROLS](state, action) {
    state.formControls = {
      ...state.formControls,
      ...action.controls,
    };
    state.invalidControls = {
      ...state.invalidControls,
      ...(action.invalidControls || {}),
    };
  },
  [TOGGLE_DELETE](state, action) {
    state.deleteIsOpen = !state.deleteIsOpen;
    state.toDeleteId = action.id;
  },
  [TOGGLE_EDIT_PACKAGING_TYPE](state, action) {
    state.formIsOpen = true;
    state.toDeleteId = '';
    state.toEditId = action.item.id;
    state.formControls.name = action.item.name;
    state.formControls.weight = action.item.weight;
    state.formControls.palletWeight = action.item.palletWeight;
    state.edit = true;
  },
  [SET_INVALID_CONTROLS](state, action) {
    state.invalidControls = {
      ...state.invalidControls,
      ...action.controls,
    };
  },
  // api
  [PACKAGING_TYPES.CREATE_PACKAGING_TYPE_SUCCESS](state, action) {
    state.formIsOpen = false;
    state.formControls = { ...defaultControls };
    state.invalidControls = { ...defaultInvalidInputs };
  },
  [PACKAGING_TYPES.DELETE_PACKAGING_TYPE_SUCCESS](state, action) {
    state.deleteIsOpen = false;
    state.toDeleteId = '';
  },
  [PACKAGING_TYPES.EDIT_PACKAGING_TYPE_SUCCESS](state, action) {
    state.formControls = { ...defaultControls };
    state.invalidControls = { ...defaultInvalidInputs };
    state.formIsOpen = false;
    state.toDeleteId = '';
    state.toEditId = '';
    state.edit = false;
  },
});

export default packagingTypes;
